import { of } from 'rxjs'
import { EpicRefined } from 'interfaces/middleware'
import { map, mergeMap } from 'rxjs/operators'
import { CurrenciesMetaGetMetaInfoRequestAction } from 'components/features/rewards/rewardsPane/store/actions/currenciesMeta'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { GET_CRYPTO_CURRENCIES_META_URL } from 'components/features/rewards/rewardsPane/constants/endpoints'
import { CryptoRewardsPaneActions } from 'components/features/rewards/rewardsPane/store/actions'

export const loadCryptoCurrenciesMetaInfoEpic: EpicRefined<CryptoRewardsPaneActions | AjaxCatchExtraActions> = (
  (action$, _, { get }) => action$.pipe(
    filterRequestOfType(CurrenciesMetaGetMetaInfoRequestAction.type, 'request'),
    mergeMap((action) => get(GET_CRYPTO_CURRENCIES_META_URL).pipe(
      map(({ response }) => {
        return action.success(response.items)
      }),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status })))
    ))
  )
)
